<div class="bg-grey-white_smoke dark:bg-contrast-black">
    <ng-template #departFilterHeader>
        <rwidget-depart-filter
            [(filterDepartTime)]="departTimeFilter"
            [routes]="routeOptions"
            [spaceWhenNotExpanded]="true"
            (filterRouteShortNamesChange)="handleRouteFilterChange($event)"
            (filterDepartTimeChange)="getData()">
            <div
                class="flex-align-center flex justify-between pb-4"
                [ngClass]="{
                    'pt-0': isMobileView,
                    'pt-1.5': !isMobileView
                }">
                <ion-icon
                    class="mt-1 h-[1.6rem] w-[1.6rem] self-baseline rounded text-secondary dark:filter-yellow"
                    *ngIf="!location?.pointOfInterest"
                    [src]="(assetsPath$ | async) + imageMapLocationPath"
                    [attr.aria-label]="'PH_ADDRESS' | translate"
                    [alt]="'PH_ADDRESS' | translate"></ion-icon>
                <ion-icon
                    class="mt-1 h-[1.6rem] w-[1.6rem] self-baseline rounded text-secondary dark:filter-yellow"
                    *ngIf="location?.pointOfInterest"
                    [src]="(assetsPath$ | async) + '/img/explore/poi.svg'"
                    [attr.aria-label]="'POI' | translate"
                    [alt]="'POI' | translate"></ion-icon>
                <h1
                    class="ml-3 min-w-0 flex-1 break-words text-base font-semibold normal-case leading-5 dark:text-contrast-yellow"
                    [class.normal-case]="env.REMOVE_UPPERCASE">
                    {{ location?.name || ('SELECTED_LOCATION' | translate) }}
                </h1>
                <div class="mt-1 flex items-start self-start">
                    <ion-button
                        class="orb-app-light:text-secondary my-0 h-8 w-8"
                        *ngIf="env.JOURNEY_PLANNER?.SHOW_SCHEDULE"
                        [attr.aria-label]="'PATH' | translate"
                        (click)="scheduleClickHandle()"
                        slot="end"
                        fill="clear">
                        <ion-icon
                            class="var-app-light:text-[#323232] h-8 w-8 dark:filter-yellow"
                            title="{{ 'PATH' | translate }}"
                            aria-label="{{ 'PATH' | translate }}"
                            src="{{ assetsPath$ | async }}/img/explore/vector.svg"></ion-icon>
                    </ion-button>
                    <ion-button
                        class="my-0 h-8 w-8"
                        *ngIf="env.EXPLORE?.SHOW_REFRESH_BUTTON"
                        [attr.aria-label]="'REFRESH' | translate"
                        (click)="refreshStopTimes()"
                        slot="end"
                        fill="clear">
                        <ion-icon
                            class="var-app-light:text-[#323232] h-8 w-8 text-secondary dark:filter-yellow"
                            title="{{ 'REFRESH' | translate }}"
                            aria-label="{{ 'REFRESH' | translate }}"
                            src="{{ assetsPath$ | async }}/img/journey-planner/icon-refresh.svg"></ion-icon>
                    </ion-button>
                    <ion-button
                        class="my-0 h-8 w-8"
                        *ngIf="env.EXPLORE?.SHOW_FAVORITE_STOPS"
                        [attr.aria-label]="'NOT_FAVORITE' | translate"
                        (click)="favoriteClickHandle()"
                        slot="end"
                        fill="clear">
                        <ion-icon
                            class="var-app-light:text-[#323232] h-8 w-8 text-secondary dark:filter-yellow"
                            *ngIf="!isFavorite"
                            title="{{ 'NOT_FAVORITE' | translate }}"
                            aria-label="{{ 'NOT_FAVORITE' | translate }}"
                            src="{{ assetsPath$ | async }}/img/explore/notFavorite.svg">
                        </ion-icon>
                        <ion-icon
                            class="var-app-light:text-[#323232] h-8 w-8 text-secondary dark:filter-yellow"
                            *ngIf="isFavorite"
                            title="{{ 'FAVORITE' | translate }}"
                            aria-label="{{ 'FAVORITE' | translate }}"
                            src="{{ assetsPath$ | async }}/img/explore/favorite.svg"></ion-icon>
                    </ion-button>
                    <ion-button
                        class="my-0 h-8 w-8 dark:filter-yellow"
                        (click)="navigateBack()"
                        slot="end"
                        fill="clear">
                        <ion-icon
                            class="var-app-light:text-grey-zambezy my-0 h-8 w-8 dark:filter-yellow"
                            title="{{ 'LOCAL_BTN_CLOSE' | translate }}"
                            attr.aria-label="{{ 'LOCAL_BTN_CLOSE' | translate }}"
                            src="{{ assetsPath$ | async }}/img/explore/cross.svg"></ion-icon>
                    </ion-button>
                </div>
            </div>
        </rwidget-depart-filter>
    </ng-template>

    <div class="flex-column container mb-4 flex gap-4 overflow-y-auto">
        <div class="shadow-md" *ngFor="let stop of loadedStops">
            <rwidget-bus-stop-short
                [stop]="stop"
                [departures]="getStopDepartures(stop.id)"
                [isLoadingDepartures]="departuresLoadingMap[stop.id]"
                (showAllClicked)="openStopView(stop.id)"
                (tripClick)="openTripDetailsView($event)"></rwidget-bus-stop-short>
        </div>
    </div>

    <ion-button
        class="var-app-light:text-primary var-app-light-dark:normal-case var-app-light-dark:m-0 var-app-light-dark:mb-12 m-4 w-full cursor-pointer text-center text-base font-semibold text-secondary dark:filter-yellow"
        *ngIf="showLoadMoreStops()"
        [class.normal-case]="env.REMOVE_UPPERCASE"
        (click)="loadMoreStops()"
        fill="clear">
        <ion-icon
            class="mr-1 text-secondary dark:text-contrast-yellow"
            *ngIf="env.EXPLORE?.STOP_VIEW?.SHOW_ICON_FOR_SHOW_MORE_STOPS"
            src="{{ assetsPath$ | async }}/img/explore/icon-arrow-down-circle.svg">
        </ion-icon>
        {{ 'SHOW_MORE_STOPS_ELLIPSIS' | translate }}
    </ion-button>
</div>
